interface TimelineConnectorLineProps {
  className?: string;
}

export function TimelineConnectorLine({
  className,
}: TimelineConnectorLineProps) {
  return (
    <div className={`absolute w-px bg-border-secondary ${className ?? ''}`} />
  );
}
